import React, { useEffect, useState } from 'react';
import {
  FaCrown,
  FaUsers,
  FaWallet,
  FaChartLine,
  FaCheckCircle,
  FaLock,
} from 'react-icons/fa';

import api from '../../api/Api';
import { useTheme } from '../../context/ThemeContext';


const UserRank = () => {

  const { isDarkMode } = useTheme();

  const [loading, setLoading] = useState(true);

  const [ranks, setRanks] = useState([]);

  const [rankReward, setRankReward] = useState(0);

  const [rankBonus, setRankBonus] = useState(0);

  useEffect(() => {
    fetchRanks();
  }, []);

  const fetchRanks = async () => {

    try {

      setLoading(true);

      const { data } = await api.get('user-rank');

      if (data?.status) {

        setRanks(data?.ranks || []);

        setRankReward(data?.rank_reward || 0);

        setRankBonus(data?.rank_bonus || 0);
      }

    } catch (err) {

      console.log(err);

    } finally {

      setLoading(false);

    }
  };

  return (

    <div className={isDarkMode ? 'dark' : 'light'}>

      <div className="user-rank-container">

        {/* HEADER */}
        <div className="user-rank-header">

          <div>

            <div className="user-rank-top-title">
              MLM Achievement
            </div>

            <div className="user-rank-main-title">
              User Rank
            </div>

            <div className="user-rank-subtitle">
              Unlock ranks & rewards by growing your network
            </div>

          </div>

        </div>

        {/* STATS */}
        <div className="rank-stats-row">

          {/* TOTAL RANK */}
          <div className="rank-stat-card">

            <div className="rank-stat-icon">
              <FaCrown />
            </div>

            <div>

              <div className="rank-stat-label">
                Total Ranks
              </div>

              <div className="rank-stat-value">
                {ranks.length}
              </div>

            </div>

          </div>

          {/* REWARD */}
          <div className="rank-stat-card">

            <div className="rank-stat-icon">
              <FaWallet />
            </div>

            <div>

              <div className="rank-stat-label">
                Rank Reward
              </div>

              <div className="rank-stat-value">
                ₹{rankReward}
              </div>

            </div>

          </div>

          {/* BONUS */}
          <div className="rank-stat-card">

            <div className="rank-stat-icon">
              <FaChartLine />
            </div>

            <div>

              <div className="rank-stat-label">
                Rank Bonus
              </div>

              <div className="rank-stat-value">
                ₹{rankBonus}
              </div>

            </div>

          </div>

        </div>

        {/* LOADING */}
        {loading ? (

          <div className="common-loading">
            Loading ranks...
          </div>

        ) : (

          <div className="common-table-wrapper">

            <table className="common-table">

            <thead>
  <tr    style={{
                background: isDarkMode ? '#1d1d1d' : '#faf8f3',
              }} >
    <th style={{ fontWeight: 700, padding: '12px 16px', fontSize: 13, letterSpacing: .4, whiteSpace: 'nowrap' }}>Rank</th>
    <th style={{  fontWeight: 700, padding: '12px 16px', fontSize: 13, letterSpacing: .4, whiteSpace: 'nowrap' }}>Direct</th>
    <th style={{  fontWeight: 700, padding: '12px 16px', fontSize: 13, letterSpacing: .4, whiteSpace: 'nowrap' }}>Self Stake</th>
    <th style={{  fontWeight: 700, padding: '12px 16px', fontSize: 13, letterSpacing: .4, whiteSpace: 'nowrap' }}>Business</th>
    <th style={{  fontWeight: 700, padding: '12px 16px', fontSize: 13, letterSpacing: .4, whiteSpace: 'nowrap' }}>Team</th>
    <th style={{  fontWeight: 700, padding: '12px 16px', fontSize: 13, letterSpacing: .4, whiteSpace: 'nowrap' }}>Reward</th>
    <th style={{  fontWeight: 700, padding: '12px 16px', fontSize: 13, letterSpacing: .4, whiteSpace: 'nowrap' }}>Status</th>
  </tr>
</thead>

              <tbody>

                {ranks.map((item, index) => (

                  <tr key={index}>

                    {/* RANK */}
                    <td>

                      <div className="common-table-flex">

                        <div className="common-table-image">

                          {item.rank_image ? (

                            <img
                              src={item.rank_image}
                              alt=""
                            />

                          ) : (

                            <FaCrown color="#000" />

                          )}

                        </div>

                        <div>

                          <div className="common-table-title">
                            {item.rank_name}
                          </div>

                          <div className="common-table-subtitle">
                            Rank Achievement
                          </div>

                        </div>

                      </div>

                    </td>

                    {/* DIRECT */}
                    <td>

                      <div className="common-table-flex">

                        <FaUsers color="#d4af37" />

                        <span className="common-table-text">
                          {item.direct_referral}
                        </span>

                      </div>

                    </td>

                    {/* SELF STAKE */}
                    <td>

                      <span className="common-table-text">
                        ₹{item.self_stake}
                      </span>

                    </td>

                    {/* BUSINESS */}
                    <td>

                      <div>

                        <div className="common-table-text">
                          ₹{item.team_business}
                        </div>

                        <div className="common-table-subtitle">
                          Team Business
                        </div>

                      </div>

                    </td>

                    {/* TEAM */}
                    <td>

                      <div className="common-table-flex">

                        <FaChartLine color="#10b981" />

                        <span className="common-table-text">
                          {item.team_size}
                        </span>

                      </div>

                    </td>

                    {/* REWARD */}
                    <td>

                      <div className="common-badge common-badge-gold">

                        <FaWallet />

                        ₹{item.reward}

                      </div>

                    </td>

                    {/* STATUS */}
                    <td>

                      <div
                        className={
                          item.status === 'completed'
                            ? 'common-badge common-badge-green'
                            : 'common-badge common-badge-orange'
                        }
                      >

                        {item.status === 'completed'
                          ? <FaCheckCircle />
                          : <FaLock />
                        }

                        {item.status}

                      </div>

                    </td>

                  </tr>

                ))}

              </tbody>

            </table>

          </div>

        )}

      </div>

    </div>
  );
};

export default UserRank;